<div class="h-full rounded-xl border border-gray-100 bg-white shadow-sm">
  <div class="flex flex-wrap items-baseline gap-2 border-b border-gray-100 px-5 py-4">
    <h3 class="font-lato text-sm font-bold uppercase tracking-wide text-blue-950">
      Circuit Milestones
      <span class="ml-1 font-normal normal-case text-brand-muted">({{ total }} in progress)</span>
    </h3>
    <p class="font-lato text-xs text-brand-muted">Excludes related Voice and SD-WAN orders</p>
  </div>

  @if (loading) {
    <div class="flex items-center justify-center py-16">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    <div class="px-4 py-2">
      <p id="circuit-milestones-chart-desc" class="sr-only">
        Bar chart showing circuit milestones for orders in progress. Contact support for tabular data.
      </p>
      <canvas
        baseChart
        id="circuit-milestones-chart"
        role="img"
        aria-label="Bar chart: Circuit Milestones"
        aria-describedby="circuit-milestones-chart-desc"
        height="320px"
        [data]="barChartData"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [type]="barChartType"
      ></canvas>
    </div>
  }
</div>
